import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const EmptyState = ({ 
  title, 
  description, 
  actionText, 
  actionPath,
  icon: Icon
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        p: 3
      }}
    >
      {Icon && (
        <Box sx={{ mb: 2, color: 'text.secondary' }}>
          <Icon sx={{ fontSize: 60 }} />
        </Box>
      )}
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        {description}
      </Typography>
      {actionText && actionPath && (
        <Button
          variant="contained"
          onClick={() => navigate(actionPath)}
          sx={{ 
            mt: 2,
            backgroundColor: '#591716',
            color: 'white',
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 700,
            px: 4,
            py: 1.5,
            '&:hover': {
              backgroundColor: '#4a1413',
              transform: 'translateY(-1px)',
            },
            '&:disabled': {
              backgroundColor: '#999',
              color: 'white',
              opacity: 0.6
            }
          }}
        >
          {actionText}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState; 